// Structure Synchronization API client (admin). Diff a source schema against N
// targets (the matrix), preview the per-target DDL, and apply it as one
// sequential background job (progress via the shared /api/progress/{token}).
import { api } from './api.js';

// body: { sourceConnId, sourceDb, targets:[{connId,db}], mirror }
export const ssDiff = (body) => api.post('/api/tools/structure-sync/diff', body);

// body: { sourceConnId, sourceDb, target:{connId,db}, mirror, kinds? } → { script }
export const ssPreview = (body) => api.post('/api/tools/structure-sync/preview', body);

// body: { targets:[{connId,db,script}] } → { token, total }
export const ssApply = (body) => api.post('/api/tools/structure-sync/apply', body);

export const ssResolve = (token, action) =>
  api.post(`/api/structure-sync/${token}/resolve`, { action });
